import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAllDepartments as apiDeleteAll } from "../../api/apiDepartments";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useDeleteAllDepartments() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: deleteAllDepartments, isPending: isDelete } = useMutation({
        mutationFn: (req) => apiDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["departments"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { deleteAllDepartments, isDelete };
}
